import Component from '../../../shared/component';

export default class Contact extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);
    this.$closeTrigger = this.$element.find('.contactMentorPopup-close');
    this.$writeTrigger = this.$element.find(
      '.contactMentorPopup-conversations-btn'
    );

    this.bindEvents();
  }

  bindEvents() {
    this.handleClosePopup = this.handleClosePopup.bind(this);

    this.$closeTrigger.on(
      'click.CloseContactMentorPopup',
      this.handleClosePopup
    );
    this.$writeTrigger.on(
      'click.CloseContactMentorPopup',
      this.handleClosePopup
    );
  }

  unbindEvents() {
    this.$closeTrigger.off(
      'click.CloseContactMentorPopup',
      this.handleClosePopup
    );
    this.$writeTrigger.off(
      'click.CloseContactMentorPopup',
      this.handleClosePopup
    );
  }

  handleClosePopup() {
    this.$element.hide();
  }
}
